module.exports = __webpack_public_path__ + "static/media/CS3 — 8.1.be039f58.PNG";